/**
 * Application configuration
 * Uses environment variables for different environments
 */

interface Config {
  API_URL: string;
  WS_URL: string;
  ENVIRONMENT: 'development' | 'production' | 'test';
  ENABLE_ANALYTICS: boolean;
  ENABLE_ERROR_TRACKING: boolean;
  GA_ID?: string;
  PUBLIC_URL: string;
}

const config: Config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  WS_URL: process.env.REACT_APP_WS_URL || 'ws://localhost:8000',
  ENVIRONMENT: (process.env.REACT_APP_ENVIRONMENT as Config['ENVIRONMENT']) || 'development',
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_ERROR_TRACKING: process.env.REACT_APP_ENABLE_ERROR_TRACKING === 'true',
  GA_ID: process.env.REACT_APP_GA_ID,
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || window.location.origin,
};

// Validate configuration in production
if (config.ENVIRONMENT === 'production') {
  if (!config.API_URL || config.API_URL.includes('localhost')) {
    console.error('Production API URL not configured properly');
  }
}

// Log configuration (without sensitive data) in development
if (config.ENVIRONMENT === 'development') {
  console.log('App Configuration:', {
    environment: config.ENVIRONMENT,
    apiUrl: config.API_URL,
    analyticsEnabled: config.ENABLE_ANALYTICS,
  });
}

export default config;